<mat-progress-bar class="m-b-20" mode="indeterminate" color="accent" *ngIf="showLoader"></mat-progress-bar>
<div fxLayout="row warp" fxLayoutGap="10px" class="m-b-20">
  <div>
    <button
      [disabled]="!patientDetails.email || this.patientDetails.emailStats&&!this.patientDetails.emailStats.emailValid"
      [ngClass]="{'selected': selectedType.name ==='email', 'stroked': selectedType.name !=='email'}"
      (click)="onSelectMedium(0)" mat-stroked-button>
      <mat-icon [ngClass]="{'text-muted': selectedType.name !=='email' }">mail</mat-icon> Email
    </button>
  </div>
  <div>
    <button
      [disabled]="!patientDetails.phone || this.patientDetails.mobileStats&&!this.patientDetails.mobileStats.mobileValid"
      [ngClass]="{'selected': selectedType.name ==='sms', 'stroked': selectedType.name !=='sms'}" mat-stroked-button
      (click)="onSelectMedium(1)">
      <mat-icon [ngClass]="{'text-muted': selectedType.name !=='sms' }">sms</mat-icon>
      Text
    </button>
  </div>
  <div>
    <button [ngClass]="{'selected': selectedType.name ==='call', 'stroked': selectedType.name !=='call'}"
      mat-stroked-button (click)="onSelectMedium(2)">
      <mat-icon [ngClass]="{'text-muted': selectedType.name !=='call' }">phone</mat-icon>
      Log a Call
    </button>
  </div>
</div>
<form (ngSubmit)="onSubmit()" [formGroup]="communicationForm">
  <div fxLayout="row wrap" class="m-b-10" *ngIf="selectedType.name !== 'call'">
    <div fxFlex.gt-sm="30" fxFlex="100">
      <mat-select placeholder="Select templates" class="dd" (selectionChange)="onSelectTemplate()"
        formControlName="dynamicTemplate">
        <mat-option value="">Custom</mat-option>
        <mat-option *ngFor="let template of templates" [value]="template.id">{{template.name}}</mat-option>
      </mat-select>
    </div>
  </div>
  <div fxLayout="row wrap" class="communication-note">
    <mat-form-field appearance="outline" *ngIf="!selectedTemplate.id">
      <mat-label>{{selectedType.placeholder}}</mat-label>
      <textarea cdkTextareaAutosize matInput formControlName="msg" class="textarea"></textarea>
    </mat-form-field>
    <div fxFlex *ngIf="selectedTemplate.id">
      <mat-accordion>
        <mat-expansion-panel (afterExpand)="onTemplateExpand(selectedTemplate)"
          (closed)="onTemplateClose(selectedTemplate)" [expanded]="selectedTemplate.isReadMore">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{selectedTemplate.name}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-progress-bar class="m-b-20" mode="indeterminate" color="accent" *ngIf="showLoaderForTemplate">
          </mat-progress-bar>
          <div class="p-10">
            <app-template *ngIf="selectedTemplate.isReadMore" @fadeIn class="pointer"
              [htmlText]="selectedTemplate.htmlText" [customInputs]="selectedTemplate.questions"
              (isCustomInputsProvided)="templateCustomInputs($event)" (showLoader)="isShowLoader($event)">
            </app-template>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="end center" class="m-t-10 m-b-20">
    <section fxFlex="12" fxFlex.lt-lg="20" *ngIf="selectedType.name !== 'call'">
      <mat-checkbox color="primary" (change)="onChangeCommunicationType()" formControlName="secure">
        {{selectedType.checkbox}}
      </mat-checkbox>
    </section>
    <div>
      <button [disabled]="!communicationForm.controls['msg'].value&&!selectedTemplate.valid" type="submit"
        mat-raised-button color="primary">{{selectedType.buttonText}}</button>
    </div>
  </div>
</form>
<app-chat-bubble (latestMessage)="latestMessage($event)" [patientId]="patientId" [patientDetails]="patientDetails" [templates]="templates"></app-chat-bubble>